export default __webpack_public_path__ + "static/media/leftside.2038afad.png";